/* OrderRenderer.js */

"use strict";

const _ = require("lodash");

class OrderRenderer {
    constructor(model) {
        this._model = model;
        this._rootElem = document.createElement("order-column");
        this._rootElem.component = this._model;

        this._firstIcon = document.createElement("base-icon-gl");
        this._firstIcon.dataset.icon = "worktrigger.first";
        this._firstIcon.setAttribute("title", "First");

        this._lastIcon = document.createElement("base-icon-gl");
        this._lastIcon.dataset.icon = "worktrigger.last";
        this._lastIcon.setAttribute("title", "Last");

        this._onlyIcon = document.createElement("base-icon-gl");
        this._onlyIcon.dataset.icon = "worktrigger.only";
        this._onlyIcon.setAttribute("title", "Only");

        this._registerListeners();
        this.render();
    }

    /********************************************/
    /* START PRIVATE COMPONENT RENDERER METHODS */
    /********************************************/

    _shutdown() {
        return new Promise((resolve /*,reject*/) => {
            this._unregisterListeners();

            this._firstIcon.remove();
            this._firstIcon = undefined;

            this._lastIcon.remove();
            this._lastIcon = undefined;

            this._onlyIcon.remove();
            this._onlyIcon = undefined;

            this._model = undefined;
            this._rootElem.remove();
            this._rootElem = undefined;
            resolve();
        });
    }

    _registerListeners() {
        this._model.on("Order", (this._onOrder = this._onOrder.bind(this)));
    }

    _unregisterListeners() {
        this._model.removeAllListeners("Order");
    }

    /*******************************************/
    /* END PRIVATE COMPONENT RENDERER METHODS  */
    /* START PUBLIC COMPONENT RENDERER METHODS */

    /*******************************************/
    /**
     * Stateless method to completely rebuild this component from the _rootElem down.
     * @returns {Promise} An ES6 promise that lets the caller know when the component has finished rendering. If a non
     * Promise is returned the caller will assume the Renderer has completed rendering.
     */
    render() {
        return new Promise((resolve /*,reject*/) => {
            this._setOrder(this._model.getValue());
            resolve();
        });
    }

    get rootElement() {
        return this.getRootElement();
    }

    getRootElement() {
        return this._rootElem;
    }

    get model() {
        return this.getModel();
    }

    getModel() {
        return this._model;
    }

    /*******************************************/
    /* END COMPONENT RENDERER METHODS */
    /* START HANDLER METHODS */

    /*******************************************/

    _onOrder(newVal) {
        this._setOrder(newVal);
    }

    /*******************************************/
    /* END HANDLER METHODS */
    /* START PRIVATE API METHODS */

    /*******************************************/

    _setOrder(value) {
        if (!_.isUndefined(value)) {
            if (value.isFirst && value.isLast) {
                this._rootElem.appendChild(this._onlyIcon);
            } else if (value.isFirst) {
                this._rootElem.appendChild(this._firstIcon);
            } else if (value.isLast) {
                this._rootElem.appendChild(this._lastIcon);
            } else {
                this._rootElem.innerHTML = "";
            }
        } else {
            this._rootElem.innerHTML = "";
        }
    }

    /*******************************************/
    /*  END PRIVATE API METHODS */
    /*******************************************/
}

module.exports = OrderRenderer;
